// extracted by mini-css-extract-plugin
export default {"root":"SurveyDetailsHeader_root__pBr-V","backLink":"SurveyDetailsHeader_backLink__F6CK0","placeHolderShimmer":"SurveyDetailsHeader_placeHolderShimmer__SdQdL"};